import { render, staticRenderFns } from "./UnreviewedBank.vue?vue&type=template&id=230e8c80&"
import script from "./UnreviewedBank.vue?vue&type=script&lang=js&"
export * from "./UnreviewedBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports